<div class="page-loader-overlay" *ngIf="isLoading">
    <div class="loader-container">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="loading-text mt-2">Loading...</p>
    </div>
</div>
